import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "./client";
import { certificateAllowanceQueryKey, certificateDetailQueryKey, certificateListQueryKey } from "./queryKeys";

export function useCreateCertificate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiFetch("/extras/api/v1/boms/certificate-of-origin", { method: "POST", body }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: certificateListQueryKey });
      queryClient.invalidateQueries({ queryKey: certificateAllowanceQueryKey });
    },
  });
}

export function useGetCertificate(certificateId, options = {}) {
  return useQuery({
    queryKey: certificateDetailQueryKey(certificateId),
    queryFn: () => apiFetch(`/extras/api/v1/boms/certificate-of-origin/${certificateId}`),
    ...options,
  });
}

export function useListCertificates(options = {}) {
  return useQuery({
    queryKey: certificateListQueryKey,
    queryFn: () => apiFetch("/extras/api/v1/boms/certificate-of-origin"),
    refetchOnMount: true,
    ...options,
  });
}

export function useDeleteCertificate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ certificateId }) => apiFetch(`/extras/api/v1/boms/certificate-of-origin/${certificateId}`, { method: "DELETE" }),
    onSuccess: (_data, { certificateId }) => {
      queryClient.invalidateQueries({ queryKey: certificateDetailQueryKey(certificateId) });
      queryClient.invalidateQueries({ queryKey: certificateListQueryKey });
    },
  });
}

export function useGetCertificateAllowance(options = {}) {
  return useQuery({
    queryKey: certificateAllowanceQueryKey,
    queryFn: () => apiFetch("/extras/api/v1/payments/certs-allowance"),
    ...options,
  });
}
